import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import styled from "styled-components";
import { Link } from "react-router-dom";
// import styles from "./styles.css";
import { downloadResumeUtil } from "../../common/downloadResumeUtil";

const RowLink = styled(Link)`
  color: #fff;
  font-size: 20px;
  text-decoration: none;
  &:hover {
    text-decoration: none;
    color: yellow;
  }
`;
const Wrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
`;
const HelloTextH2 = styled.h2`
  color: #fff;
  font-size: 25px;
  text-align: center;
`;

const NameTextH1 = styled.h1`
  text-align: center;
  line-height: 0.9;
  color: yellow;
  font-size: 4rem;
  font-family: "Bungee", cursive;
`;

const OptionsContainer = styled.div`
  margin: 0 auto;
`;

const OptionRow = styled(Row)`
  margin: 30px auto;
`;

const OptionColumn = styled(Col)`
  text-align: center;
`;
function MainContainer() {
  const handleAlert = (e) => {
    alert("Coming soon!");
    e.preventDefault();
  };
  return (
    <Wrapper>
      <HelloTextH2>Hello there! I'm</HelloTextH2>
      <NameTextH1>RAJDEEP JADHAV</NameTextH1>
      <OptionsContainer>
        <OptionRow>
          <OptionColumn>
            <RowLink to={"/about-me"}>About Me</RowLink>
          </OptionColumn>
          <OptionColumn>
            <RowLink to={"/qualifications"}>Education</RowLink>
          </OptionColumn>
        </OptionRow>
        <OptionRow>
          <OptionColumn>
            <RowLink to={"/skills"}>Skills</RowLink>
          </OptionColumn>
          <OptionColumn>
            <RowLink onClick={downloadResumeUtil}>Resume</RowLink>
          </OptionColumn>
        </OptionRow>
        <OptionRow>
          <OptionColumn>
            <RowLink to={"/projects"}>Projects</RowLink>
          </OptionColumn>
          <OptionColumn>
            <RowLink to={"/experience"} onClick={handleAlert}>
              Experience
            </RowLink>
          </OptionColumn>
        </OptionRow>
        <OptionRow>
          <OptionColumn>
            <RowLink to={"/contact"}>Contact</RowLink>
          </OptionColumn>
        </OptionRow>
      </OptionsContainer>
    </Wrapper>
  );
}

export default MainContainer;
